/*
 * @Author: wangsx
 * @Date: 2020-07-29 23:43:30
 * @LastEditTime: 2022-01-12 17:18:50
 * @LastEditors: your name
 * @Description: 验证函数
 */

/**
 * 验证手机号码、含区号固定电话、不含区号固定电话
 * @param {String} tel
 */
const checkTel = tel => {
  var pattern = /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^[0−9]3,4[0-9]{3,8}$)|(^0{0,1}13[0-9]{9}$)|(^1[0-9]{10}$)/;
  console.log(tel);
  if (tel.toString().length !== 11) {
    return false;
  } else if (pattern.test(tel)) {
    return true;
  } else {
    return false;
  }
};
/**
 * 验证邮箱地址
 * @param {*} email
 * @returns
 */
const checkEmail = email => {
  var pattern = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
  if (pattern.test(email)) {
    return true;
  } else {
    return false;
  }
};
/**
 * 验证身份证
 * @param {*} code
 */
const checkIdCard = codeId => {
  // 加权因子
  var weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  // 校验码
  var checkCode = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

  var code = codeId + "";
  var last = codeId[17]; // 最后一位

  var seventeen = code.substring(0, 17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr = seventeen.split("");
  var len = arr.length;
  var num = 0;
  for (var i = 0; i < len; i++) {
    num = num + arr[i] * weightFactor[i];
  }

  // 获取余数
  var resisue = num % 11;
  var lastNo = checkCode[resisue];

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcardPatter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  var format = idcardPatter.test(codeId);

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return !!(last === lastNo && format);
};

export {
  checkEmail, // 验证邮箱
  checkTel, // 正则手机格式校验
  checkIdCard // 验证身份证
};